(function (module) {
    "use strict";

    module.service("chamferService", [function(this: $TSFixMe) {
        var self = this;

        self.maxSliderValue = 500;
        self.defaultSliderValue = self.maxSliderValue / 2

        self.createFromOutputArray = (startMonth: $TSFixMe, endMonth: $TSFixMe, launchDate: $TSFixMe, outputArray: $TSFixMe) => {
            let tableData = [];
            let index = 0;
            const startMonthMoment = moment.utc(startMonth);
            const endMonthMoment = moment.utc(endMonth);

            const volumeForForecast = outputArray;            
            
            const groupByYear = _.groupBy(volumeForForecast, (_: $TSFixMe, i: $TSFixMe) => startMonthMoment.clone().add(i, 'months').year());

            for (const year in groupByYear) {
                const monthsInYear = self.countMonthsInYear(year, startMonth, endMonth, launchDate);
                const firstMonthIndexInYear = startMonthMoment.year() != Number(year) ?
                    0 : startMonthMoment.diff(moment.utc(`${year}-1`, 'YYYY-M'), 'months');
                let yearHolder = {
                    year: year,
                    data: [] as $TSFixMe[],
                    targetSum: _.reduce(groupByYear[year], (memo: $TSFixMe, v: $TSFixMe) => v + memo, 0),
                    displayDetails: false
                };

                for (let month = 1; month <= 12; month++) {
                    const monthMoment = moment.utc(`${year}-${month}`, 'YYYY-M');
                    if (monthMoment.isBetween(startMonthMoment, endMonthMoment, 'months', '[]')) {
                        const value = groupByYear[year][month - 1 - firstMonthIndexInYear];
                        const percentageOfYear = 100 * value / yearHolder.targetSum;
                        yearHolder.data.push({
                            index, value, month, percentageOfYear,
                            proportion: self.defaultSliderValue * monthsInYear * percentageOfYear / 100
                        });
                        ++index;
                    } else {
                        yearHolder.data.push(null);
                    }
                }
                tableData.push(yearHolder);
            }
            return tableData;
        }

        self.createFromYearlyData = (yearlyData: $TSFixMe, startMonth: $TSFixMe, endMonth: $TSFixMe, launchDate: $TSFixMe, outputArray: $TSFixMe) => {

            if (angular.isUndefinedOrNull(yearlyData))
                return;

            let tableData = [];
            let index = 0;
            const startMonthMoment = moment.utc(startMonth);
            const endMonthMoment = moment.utc(endMonth);
            const launchDateMoment = moment.utc(angular.isUndefined(launchDate) ? null : launchDate);

            for (const yearData of yearlyData) {
                const monthsInYear = self.countMonthsInYear(yearData.year, startMonth, endMonth, launchDate);

                let yearHolder = {
                    year: yearData.year,
                    data: [] as $TSFixMe[],
                    targetSum: yearData.volume,
                    displayDetails: false
                };

                for (let month = 1; month <= 12; month++) {
                    const monthMoment = moment.utc(`${yearData.year}-${month}`, 'YYYY-M');

                    if (monthMoment.isBetween(startMonthMoment, endMonthMoment, 'months', '[]')) {
                        const isBeforeLaunchDate = monthMoment.isBefore(launchDateMoment);
                        const value = isBeforeLaunchDate ? 0 : yearData.volume / monthsInYear;

                        yearHolder.data.push({
                            index, value, month,
                            proportion: isBeforeLaunchDate ? 0 : self.defaultSliderValue,
                            percentageOfYear: isBeforeLaunchDate ? 0 : 100 / monthsInYear
                        });
                        outputArray[index] = value;
                        ++index;
                    } else {
                        yearHolder.data.push(null);
                    }
                }
                tableData.push(yearHolder);
            }

            const forecastLength = Math.floor(endMonthMoment.diff(startMonthMoment, 'months')) + 1;
            for (; index < forecastLength; index++) {
                outputArray[index] = 0;
            }

            return tableData;
        }

        self.countMonthsInYear = (year: $TSFixMe, forecastStartDate: $TSFixMe, forecastEndDate: $TSFixMe, launchDate: $TSFixMe) => {

            if (launchDate && year == launchDate.getFullYear()) {
                return 12 - launchDate.getMonth();
            } else if (year == forecastStartDate.getFullYear()) {
                return 12 - forecastStartDate.getMonth();
            } else if (year == forecastEndDate.getFullYear()) {
                return forecastEndDate.getMonth() + 1;
            } else {
                return 12;
            }
        }

        self.valueChange = (yearData: $TSFixMe, monthData: $TSFixMe, monthDataIndex: $TSFixMe, outputArray: $TSFixMe) => {
            outputArray[monthData.index] = monthData.value;
            const nextMonthIndex = getNextMonthIndex(yearData.data, monthDataIndex);
            const nextMonthData = yearData.data[nextMonthIndex];
            
            const sum = _.chain(yearData.data).filter((v: $TSFixMe, i: $TSFixMe) => i != nextMonthIndex && !angular.isUndefinedOrNull(v)).reduce((memo: $TSFixMe, mData: $TSFixMe) => mData.value + memo, 0).value();
            nextMonthData.value = yearData.targetSum - sum;
            outputArray[nextMonthData.index] = nextMonthData.value;
            recalculatePercentage(yearData);
            recalculateProportion(yearData);
        }

        self.percentageOfYearChange = (yearData: $TSFixMe, monthData: $TSFixMe, monthDataIndex: $TSFixMe, outputArray: $TSFixMe) => {
            monthData.value = yearData.targetSum * monthData.percentageOfYear / 100;
            outputArray[monthData.index] = monthData.value;
            const nextMonthIndex = getNextMonthIndex(yearData.data, monthDataIndex);
            const nextMonthData = yearData.data[nextMonthIndex];
            
            const percentageSum = _.chain(yearData.data).filter((v: $TSFixMe, i: $TSFixMe) => i != nextMonthIndex && !angular.isUndefinedOrNull(v)).reduce((memo: $TSFixMe, mData: $TSFixMe) => mData.percentageOfYear + memo, 0).value();
            nextMonthData.percentageOfYear = 100 - percentageSum;
            nextMonthData.value = yearData.targetSum * nextMonthData.percentageOfYear / 100;
            outputArray[nextMonthData.index] = nextMonthData.value;
            recalculateProportion(yearData);
        }

        self.proportionChanged = (yearData: $TSFixMe, outputArray: $TSFixMe) => {
            
            const proportionSum = _.chain(yearData.data).filter((v: $TSFixMe) => !angular.isUndefinedOrNull(v)).reduce((memo: $TSFixMe, item: $TSFixMe) => memo + item.proportion, 0).value();
            
            for (const monthData of _.filter(yearData.data, (v: $TSFixMe) => !angular.isUndefinedOrNull(v))) {
                const proportion = monthData.proportion / proportionSum;
                monthData.value = proportion * yearData.targetSum;
                monthData.percentageOfYear = proportion * 100;
                outputArray[monthData.index] = monthData.value;
            }
        }

        self.resetValues = (yearData: $TSFixMe, startMonth: $TSFixMe, endMonth: $TSFixMe, launchDate: $TSFixMe, outputArray: $TSFixMe) => {
            const launchDateMoment = moment.utc(angular.isUndefined(launchDate) ? null : launchDate);
            const monthsInYearCount = self.countMonthsInYear(yearData.year, startMonth, endMonth, launchDate);
            
            for (const monthData of _.filter(yearData.data, (v: $TSFixMe, i: $TSFixMe) => !angular.isUndefinedOrNull(v))) {
                const monthMoment = moment.utc(`${yearData.year}-${monthData.month}`, 'YYYY-M');
                const isBeforeLaunchDate = monthMoment.isBefore(launchDateMoment);
                monthData.value = isBeforeLaunchDate ? 0 : yearData.targetSum / monthsInYearCount;
                monthData.proportion = isBeforeLaunchDate ? 0 : self.defaultSliderValue;
                monthData.percentageOfYear = isBeforeLaunchDate ? 0 : 100 / monthsInYearCount;
                outputArray[monthData.index] = monthData.value;
            }
        }

        self.createChartDataFromYearlyData = (yearlyData: $TSFixMe, startMonth: $TSFixMe, endMonth: $TSFixMe, launchDate: $TSFixMe, outputArray: $TSFixMe) => {
            const startMonthMoment = moment.utc(startMonth);
            const endMonthMoment = moment.utc(endMonth);
            const launchDateMoment = moment.utc(angular.isUndefined(launchDate) ? null : launchDate);
            let originalData = [];

            for (const yearData of yearlyData) {
                const monthsInYear = self.countMonthsInYear(yearData.year, startMonth, endMonth, launchDate);
                for (let month = 1; month <= 12; month++) {
                    const monthMoment = moment.utc(`${yearData.year}-${month}`, 'YYYY-M');

                    if (monthMoment.isBetween(startMonthMoment, endMonthMoment, 'months', '[]')) {
                        const value = monthMoment.isBefore(launchDateMoment) ? 0 : yearData.volume / monthsInYear;
                        originalData.push(value);
                    }
                }
            }

            return [originalData, outputArray];
        }

        self.createChartDataFromOutputArray = (startMonth: $TSFixMe, endMonth: $TSFixMe, launchDate: $TSFixMe, outputArray: $TSFixMe) => {
            const startMonthMoment = moment.utc(startMonth);

            const volumeForForecast = outputArray;            
            
            const groupByYear = _.groupBy(volumeForForecast, (_: $TSFixMe, i: $TSFixMe) => startMonthMoment.clone().add(i, 'months').year());

            let originalData = [];

            for (const year in groupByYear) {
                
                const yearSum = _.reduce(groupByYear[year], (memo: $TSFixMe, v: $TSFixMe) => v + memo, 0);
                const monthsCount = self.countMonthsInYear(year, startMonth, endMonth, launchDate);
                const monthValue = yearSum / monthsCount;
                for (let month = 1; month <= 12; ++month) {
                    const monthMoment = moment.utc(`${year}-${month}`, 'YYYY-M');
                    if (monthMoment.isBetween(startMonth, endMonth, 'months', '[]')) {
                        originalData.push(launchDate && monthMoment.isBefore(launchDate) ? 0 : monthValue);
                    }
                }
            }
            return [originalData, volumeForForecast];
        }

        function getNextMonthIndex(monthlyValues: $TSFixMe, monthIndex: $TSFixMe) {
            let nextIndex = (monthIndex + 1) % 12;

            while (angular.isUndefinedOrNull(monthlyValues[nextIndex])) {
                nextIndex = (nextIndex + 1) % 12;
            }
            return nextIndex;
        }

        function recalculateProportion(yearData: $TSFixMe) {
            
            for (const monthData of _.filter(yearData.data, (v: $TSFixMe) => !angular.isUndefinedOrNull(v))) {
                monthData.proportion = self.defaultSliderValue * 12 * monthData.percentageOfYear / 100;
            }
        }

        function recalculatePercentage(yearData: $TSFixMe) {
            
            for (const monthData of _.filter(yearData.data, (v: $TSFixMe) => !angular.isUndefinedOrNull(v))) {
                monthData.percentageOfYear = monthData.value / yearData.targetSum * 100;
            }
        }
    }]);

})(angular.module('topline.chamferForecast'));